/**
 * The guides under /guides/, in the order the index lists them. No imports here: react-router.config.ts reads this
 * list to prerender the pages.
 */
export const GUIDE_SLUGS = [
  'night-order',
  'strategy',
  'decks',
  'marks-and-artifacts',
  'remote-game-night',
  'bots',
  'base-game',
  'daybreak',
  'bonus-roles',
  'vampire',
  'alien',
] as const
export type GuideSlug = (typeof GUIDE_SLUGS)[number]
